import React from "react";
import moment from "moment";
import FormattedCurrencyNumberCustom from "../formatted-currency-number-custom";
import { useRecordContext } from "react-admin";

export const ExpectedDateField = ({ source }) => {
  const record = useRecordContext();
  return (
    <span>
      {`${moment(record[source]).format("MM/DD/YYYY")} - ${moment(
        record[source]
      )
        .add(2, "days")
        .format("MM/DD/YYYY")}`}
    </span>
  );
};

export const AmountField = ({ source }) => {
  const record = useRecordContext();
  return record[source] ? (
    <span>
      {record["currency"]} {record[source]}
    </span>
  ) : (
    "-"
  );
};

export const LineItemTotalField = ({ source }) => {
  const record = useRecordContext();
  return record["unit_price"] ? (
    <span>
      {record.currency}{" "}
      <FormattedCurrencyNumberCustom
        value={(record["unit_price"] * record["quantity"]).toFixed(2)}
      />
    </span>
  ) : (
    "-"
  );
};

export const PaymentAmountField = ({ source }) => {
  const record = useRecordContext();
  return record["payment_amount"] ? (
    <span>
      {record.currency}{" "}
      <FormattedCurrencyNumberCustom
        value={record["payment_amount"].toFixed(2)}
      />
    </span>
  ) : (
    "-"
  );
};

export const MaterialQtyUom = ({ source }) => {
  const record = useRecordContext();
  return record["quantity"] ? (
    <span>
      {" "}
      {record["quantity"]}{" "}
      {record["ordered_uom"] === "TON" || record["ordered_uom"] === "TN"
        ? "T"
        : record["ordered_uom"]}{" "}
    </span>
  ) : (
    "-"
  );
};

export const ConvQtyField = ({ source }) => {
  const record = useRecordContext();
  return record.product_master && record.product_master.show_conversion ? (
    <span>
      {(record.product_master.conversion_factor * record[source]).toFixed(2)}
    </span>
  ) : null;
};

export const ConvQtyUomField = ({ source }) => {
  const record = useRecordContext();
  return record.product_master && record.product_master.show_conversion ? (
    <span>{record.product_master.conversion_uom_name}</span>
  ) : null;
};

export const CamelCaseField = ({ source }) => {
  const record = useRecordContext();
  let camelCased =
    record[source] &&
    record[source].replace(/_([a-z])/g, (g) => ` ${g[1].toUpperCase()}`);
  camelCased = camelCased.charAt(0).toUpperCase() + camelCased.slice(1);
  return camelCased ? <span>{camelCased}</span> : "-";
};
